<template>
  <div class="diy-sharingGoods" :style="'background:'+itemStyle.background">
  <div class="goods-item" v-for="(dataItem,index) in datalist" :key="index">
    <form @click="_onTargetGoods(dataItem.goods_id)" report-submit="true">
      <button formType="submit" class="btn-normal dis-flex" :data-id="dataItem.goods_id">
        <!-- 商品图片 -->
        <div class="goods-item_left">
          <img style="width:100%" :src="dataItem.image">
        </div>
        <div class="goods-item_right">
          <!-- 商品名称 -->
          <div v-if="itemStyle.show.goodsName" class="goods-item_title twolist-hidden">
            <p>{{ dataItem.goods_name }}</p>
          </div>
          <div class="goods-item_desc">
            <!-- 商品卖点 -->
            <div v-if="itemStyle.show.sellingPoint" class="desc-selling_point onelist-hidden">
              <p>{{ dataItem.selling_point }}</p>
            </div>
            <!-- 拼团信息 -->
            <div class="desc-situation">
              <p class="iconfont icon-pintuan_huaban"></p>
              <p class="people">{{ dataItem.people }}人团</p>
              <p class="col-9">已有{{ dataItem.goods_sales }}人进行拼团</p>
            </div>
            <!-- 商品价格 -->
            <div class="desc_footer">
              <p class="price_x" v-if="itemStyle.show.sharingPrice">¥{{ dataItem.sharing_price }}</p>
              <p class="price_y col-9" v-if="itemStyle.show.linePrice && dataItem.line_price > 0">¥{{ dataItem.line_price }}</p>
            </div>
          </div>
          <div class="btn-settlement">去拼团</div>
        </div>
      </button>
    </form>
  </div>
</div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle","datalist"],
  created(){
  },
  activated() {
  },
  methods:{
    _onTargetGoods(id){
        this.$router.push({
          path: '/pages/sharing/goods/index',
          query:{
              id:id
          } 
        })
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 商品组 */

.diy-sharingGoods {
  padding: 10px;
}

.goods-item {
  height: 160px;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
}

.goods-item:last-child {
  margin-bottom: 0;
}

/* 商品图片 */

.goods-item_left {
  display: flex;
  width: 40%;
  background: #fff;
  align-items: center;
}

.goods-item_left img {
  display: block;
  width: 120px;
  height: 120px;
}

.goods-item_right {
  position: relative;
  width: 60%;
}

/* 商品名称 */

.goods-item_right .goods-item_title {
  height: 36px;
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.3;
  color: #333;
}

.goods-item_desc {
  margin-top: 8px;
}

/* 商品卖点 */

.desc-selling_point {
  width: 200px;
  height: 16px;
  font-size: 12px;
  line-height: 1.4;
  color: #ff495e;
}

/* 拼团信息 */

.desc-situation {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.3;
  color: rgb(240, 60, 60);
}

.desc-situation .people {
  margin: 0 6px;
}

/* 商品价格 */

.desc_footer {
  margin-top: 6px;
  font-size: 12px;
}

.desc_footer .price_x {
  margin-right: 10px;
  color: rgb(240, 60, 60);
  font-size: 14px;
}

.desc_footer .price_y {
  p-decoration: line-through;
}

/* 去拼团按钮 */

.goods-item .btn-settlement {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 0 14px;
  border-radius: 20px;
  background: linear-gradient(to right, rgb(235, 53, 107) 0%, rgb(240, 60, 60) 100%);
  box-shadow: 0 2px 10px -2px rgb(235, 53, 107);
  font-size: 14px;
  line-height: 27px;
  p-align: center;
  color: #fff;
}

</style>